import React, {useState} from 'react'
import {connect} from 'react-redux'
import ListGroup from 'jbc-front/components/ListGroup'
import {Link, useLocation} from 'react-router-dom'
import {recordDisplay} from 'utils'
import styles from 'notifications/List.scss'
import {get} from 'lodash'
import {PreviewPdfModal} from 'components/modals/PreviewPdfModal'
import SearchForm from 'notifications/list/SearchForm'
import PaginatorWithResult from 'notifications/list/PaginatorWithResult'
import {getSavedDisplayNotificationLimit} from 'notifications/list/utils'
import {Tab} from 'components/ui/Tab'
import {Spacer} from 'jbc-front/components/presenters/Spacer'
import classnames from 'classnames'

const DATE_WITH_YEAR_LENGTH = 9

const notificationTypes = [
  {id: 'all', name: 'すべて'},
  {id: 'MyNumberNotification', name: 'マイナンバーの提出'},
  {id: 'others', name: 'その他'},
]

const Notification = ({notification, showPreviewPdf}) => {
  const dateOrTime = recordDisplay.dateOrTime(notification.notification_content.created_at)
  return (
    <ListGroup.Item
      className={styles.notificationlist}
      key={notification.id}
      {...(notification.notification_content.link
        ? {
            ...(notification.notification_content.link.startsWith('http')
              ? {href: notification.notification_content.link, as: 'a'}
              : {
                  to: notification.notification_content.link,
                  as: Link,
                }),
            target: notification.notification_content.target_blank ? '_blank' : undefined,
          }
        : notification.notification_content.type === 'FileUploadNotification'
          ? {
              as: 'a',
              onClick: () => {
                showPreviewPdf(notification.notification_content)
              },
            }
          : {})}
    >
      <span className={dateOrTime.length < DATE_WITH_YEAR_LENGTH ? styles.date : styles.dateWithYear}>
        {dateOrTime}
      </span>
      {notification.notification_content.title}
      {notification.notification_content.link ? <ListGroup.Icon /> : null}
    </ListGroup.Item>
  )
}

export const Notifications = ({notifications, title, styles}) => {
  const [previewPdfData, setPreviewPdfData] = useState()
  const showPreviewPdf = (content) => {
    const {
      procedure_status_id: procedureStatusId,
      report_name: num,
      employee_dependent_id: dependentId,
      title,
    } = content
    const url =
      `/api/procedure_statuses/${procedureStatusId}/pdf_to_be_uploaded?type=${num}` +
      (dependentId ? `&employee_dependent_id=${dependentId}` : '')
    setPreviewPdfData({
      title,
      url,
      pdf: url,
    })
  }

  return (
    <ListGroup>
      <PreviewPdfModal data={previewPdfData} onClose={() => setPreviewPdfData(undefined)} />
      <ListGroup.Title>{title}</ListGroup.Title>
      {notifications.length > 0 ? (
        notifications.map((notification) => (
          <Notification key={notification.id} notification={notification} showPreviewPdf={showPreviewPdf} />
        ))
      ) : (
        <ListGroup.Item className={styles.empty}>{title}はまだありません</ListGroup.Item>
      )}
    </ListGroup>
  )
}
const List = ({list, currentUser}) => {
  const {pathname} = useLocation()
  const title = ['full_admin', 'office_admin'].includes(get(currentUser, 'client_role.client_role_type'))
    ? '従業員の通知'
    : '管理者からの通知'

  return (
    <div>
      {currentUser.client_role.client_role_type === 'member' ? (
        <div className="l-title-wrap">
          <h1 className="m-title-main">通知一覧</h1>
        </div>
      ) : (
        <div>
          <div className={classnames(styles.tabsWrap, 'u-pb0')}>
            <div className={styles.tabs}>
              <Tab to="/system_announces">お知らせ一覧</Tab>
              <Tab active>通知一覧</Tab>
              <Tab to="/alerts">アラート一覧</Tab>
            </div>
          </div>
          <Spacer direction="y" size={30} />
        </div>
      )}
      <div className="l-wrap-s">
        <SearchForm notificationTypes={notificationTypes} />
        {list.length > 0 && <Notifications notifications={list} title={title} styles={styles} />}
        <PaginatorWithResult limit={getSavedDisplayNotificationLimit(pathname, currentUser)} />
      </div>
    </div>
  )
}

export default connect((state) => ({
  currentUser: state.session.currentUser,
  list: state.notificationsData.list.data,
}))(List)
